module.exports = __webpack_public_path__ + "img/es.f37e3742.svg";